var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleZap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#8977F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5388 12.5455C22.8658 12.5455 23.111 12.7091 23.2745 13.0364C23.438 13.2818 23.3563 13.6091 23.1928 13.8545L15.0183 23.6727C14.8548 23.9182 14.6096 24 14.3644 24C14.2826 24 14.1191 24 14.0374 23.9182C13.7104 23.8364 13.4652 23.4273 13.5469 23.1L14.2826 17.4545H7.82482C7.49784 17.4545 7.2526 17.2909 7.08912 17.0455C6.92563 16.7182 7.00737 16.3909 7.17086 16.1455L15.3453 6.32727C15.5905 6 15.9993 5.91818 16.3262 6.08182C16.6532 6.16364 16.8985 6.57273 16.8167 6.9L16.081 12.5455H22.5388ZM15.9992 16.7175L15.5088 20.4811L20.7404 14.1811H15.1001C14.9366 14.1811 14.6913 14.0993 14.5278 13.9357C14.4461 13.772 14.3644 13.5266 14.3644 13.2811L14.7731 9.51748L9.54143 15.8175H15.1818C15.427 15.8175 15.6723 15.8993 15.8358 16.0629C15.9175 16.2266 15.9992 16.472 15.9992 16.7175Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleZap);
export default __webpack_public_path__ + "static/media/circle-zap.47a96790.svg";
export { ForwardRef as ReactComponent };